import * as React from "react";
import { AppContext } from "./AppContext/AppContext";
import "./bootstrap-page";

export const App: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    return <AppContext>{children}</AppContext>;
};
